module.exports = __webpack_public_path__ + "img/app.759a2af1.png";